import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=4fff1cb6&scoped=true&"
import script from "./qa.vue?vue&type=script&lang=js&"
export * from "./qa.vue?vue&type=script&lang=js&"
import style0 from "./qa.vue?vue&type=style&index=0&id=4fff1cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff1cb6",
  null
  
)

export default component.exports